import React, { useState, useEffect } from "react";
// Chakra imports
import {
  HStack,
  Flex,
  Box,
  Spacer,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  Td,
  useColorModeValue,
  Progress,
  Button,
  useDisclosure,
  Icon,
  Grid,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  Select,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { FaCircleNotch, FaPencilAlt, FaPlus, FaTrashAlt, FaArchive } from "react-icons/fa";
// Custom components
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import TablesProjectRow from "components/Tables/TablesProjectRow";
import TablesTableRow from "components/Tables/TablesTableRow";
import useGetProducts from "../../hooks/useGetProducts";
import useGetStocks from "../../hooks/useGetStocks";
import CreateProduct from "../../modals/CreateProduct";
import EditProduct from "../../modals/EditProduct";
import CreateStock from "../../modals/CreateStock";
import CreateProductArchive from "../../modals/CreateProductArchive";
import EditStock from "modals/EditStock";
import Pagination from "views/Custom/Pagination";
import { MySearchBar } from "views/Custom/MySearchBar";
import StockHistory from "../../modals/StockHistory";
import { useAuth } from "contexts/auth";

function Inventory() {
  const [ keyword, setKeyword ] = useState("");
  const [ supplierKeyword, setSupplierKeyword ] = useState("");
  const [ withStocks, setWithStocks ] = useState(true);
  const orderByRules = ["nameAsc", "nameDesc", "descriptionAsc", "descriptionDesc"];
  const orderByRulesDisplay = ["Name Ascending", "Name Descending", "Description Ascending", "Description Descending"];
  const [ orderBy, setOrderBy ] = useState(orderByRules[0]);
  const [ page, setPage ] = useState(1); 
  const pageLimit = 10;
  let { 
    products, 
    totalProducts, 
    setGettingProducts, 
    gettingProducts, 
    gettingProductsReqSuccess 
  } = useGetProducts({ 
    page, 
    limit: pageLimit,
    keyword: keyword != "" ? keyword : undefined, 
    supplierKeyword: supplierKeyword != "" ? supplierKeyword : undefined, 
    withStocks: withStocks,
    orderBy: orderBy,
  });

  const authUser = useAuth();
  const { isOpen: isOpenCreate, onOpen: onOpenCreate, onClose: onCloseCreate } = useDisclosure();
  const { isOpen: isOpenEdit, onOpen: onOpenEdit, onClose: onCloseEdit } = useDisclosure();
  const [ toEditProduct, setToEditProduct ] = useState(null);
  const [ toAddStocks, setToAddStocks ] = useState(null);
  const [ toViewStocks, setToViewStocks ] = useState(null);
  const [ toArchive, setToArchive ] = useState(null);

  const [ stockPage, setStockPage ] = useState(1); 
  const stockPageLimit = 10;
  let { 
    stocks, 
    totalStocks, 
    setGettingStocks, 
    gettingStocks, 
    gettingStocksReqSuccess 
  } = useGetStocks({ 
    page: stockPage, 
    limit: stockPageLimit, 
    productId: toViewStocks,
  });
  const { isOpen: isOpenCreateStock, onOpen: onOpenCreateStock, onClose: onCloseCreateStock } = useDisclosure();
  const { isOpen: isOpenViewStocks, onOpen: onOpenViewStocks, onClose: onCloseViewStocks } = useDisclosure();
  const { isOpen: isOpenArchive, onOpen: onOpenArchive, onClose: onCloseArchive } = useDisclosure();
  // const { isOpen: isOpenEditStock, onOpen: onOpenEditStock, onClose: onCloseEditStock } = useDisclosure();
  // const [ toEditStock, setToEditStock ] = useState(null);
  // console.log(authUser);

  useEffect(() => {
    reloadPage();
  }, [page]);

  useEffect(() => {
    // console.log({keyword, supplierKeyword})
    if (page == 1) {
      reloadPage();
    } else {
      setPage(1);
    }
  }, [keyword, supplierKeyword]);

  useEffect(() => {
    // console.log({keyword, supplierKeyword})
    if (page == 1) {
      reloadPage();
    } else {
      setPage(1);
    }
  }, [withStocks]);

  useEffect(() => {
    // console.log({keyword, supplierKeyword})
    if (page == 1) {
      reloadPage();
    } else {
      setPage(1);
    }
  }, [orderBy]);


  useEffect(() => {
    // console.log(products);
    if (toAddStocks) {
      onOpenCreateStock();
    }
  }, [toAddStocks]);



  // useEffect(() => {
  //   console.log(products);
  // }, [products]);


  const reloadPage = () => {
    setGettingProducts(true);
  }

  const selectEditItem = (id) => {
    // console.log(id);
    const user = products.find((c) => c.id === id);
    // console.log(user.email);
    setToEditProduct(user);
    onOpenEdit(true);
  }

  const selectViewStocks = (id) => {
    // console.log(id);
    const user = products.find((c) => c.id === id);
    // console.log(user.email);
    setToViewStocks(user);
    onOpenViewStocks(true);
  }


  // const selectEditStock = (id) => {
  //   // console.log(id);
  //   const user = stocks.find((c) => c.id === id);
  //   // console.log(user.email);
  //   setToEditStock(user);
  //   onOpenEditStock(true);
  // }

  const getProductName = () => {
    let name = '(All)';
    if (toViewStocks) {
      products.forEach(p => {
        if (p.id == toViewStocks) {
          name = `(${p.name})`;
        }
      })
    }
    return name;
  }

  const textColor = useColorModeValue("gray.700", "white");

  return (
    <>
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>

      <Card overflowX={{ sm: "scroll", xl: "hidden" }}>
        <CardHeader p="6px 0px 22px 0px">
          <Flex w="100%"
            flexDirection={{
              sm: "row",
              md: "row",
            }}
            alignItems={{ xl: "center" }}>
            <MySearchBar 
              keyword={keyword}
              setKeyword={setKeyword}
              onReload={reloadPage}
              hint="By Item"
            />
            <Box marginLeft={4}/>
            <MySearchBar 
              keyword={supplierKeyword}
              setKeyword={setSupplierKeyword}
              onReload={reloadPage}
              hint="By Supplier"
            />
            <Box marginLeft={4}/>
            <HStack>
              <Select 
                defaultValue={'WithStocks'}
                onChange={(e) => {
                  if (e.target.value == 'All') {
                    setWithStocks(null);
                  } else if (e.target.value == 'WithStocks') {
                    setWithStocks(true);
                  } else if (e.target.value == 'WithOutStocks') {
                    setWithStocks(false);
                  }
                }}
              >
                <option key="stocks-all" value="All">All</option>
                <option key="stocks-with" value="WithStocks">With Stocks</option>
                <option key="stocks-without" value="WithOutStocks">Without Stocks</option>
              </Select>
            </HStack>

            <Box marginLeft={4}/>
            Order by <Box marginLeft={4}/>
            <HStack>
              <Select 
                defaultValue={orderByRules[0]}
                onChange={(e) => {
                  orderByRules.forEach((val) => {
                    if (e.target.value == val) {
                      setOrderBy(val);
                    }
                  });
                }}
              >
                {orderByRules.map((val, indx) => {
                  return <option key={val} value={val}>{orderByRulesDisplay[indx]}</option>
                })}
              </Select>
            </HStack>

            <Spacer />
            <Box>
            {authUser.auth.role != 'auditor'
                            ?
              <Button colorScheme="teal" mr="4" onClick={onOpenCreate}>
                Create New
              </Button>
              : null 
            }
            </Box>
          </Flex>
        </CardHeader>
        <CardBody>
          <Flex direction="column" w="100%">
            <Table variant="simple" color={textColor}>
              <Thead>
                <Tr my=".8rem" p={2} color="gray.400">
                  <Th p={2} color="gray.400">Name</Th>
                  <Th p={2} color="gray.400">Description</Th>
                  <Th p={2} color="gray.400">Vehicle</Th>
                  <Th p={2} color="gray.400">Stocks</Th>
                  <Th p={2} color="gray.400">Actions</Th>
                  <Th></Th>
                </Tr>
              </Thead>
              <Tbody>
                {gettingProducts ? 
                  <Tr my=".8rem" >
                    <Td minWidth={{ sm: "250px" }} p={2} colSpan={4}>
                      <Progress isIndeterminate />
                    </Td>
                  </Tr>
                  : products.map((product) => {
                    return (
                      <Tr my=".8rem" key={`prod-item-${product.id}`}>
                        <Td  p={2}>{product.name}</Td>
                        <Td  p={2}>{product.description}</Td>
                        <Td  p={2} fontSize="sm">
                          {product.carMake ? product.carMake : ''} {product.carType ? ` ${product.carType}` : ''} 
                          {product.carYear ? ` (${product.carYear})` : ''} <br/>
                          {product.carPart ? `Part No: ${product.carPart}` : ''} 
                        </Td>
                        <Td  p={2}>
                          {product.totalStocks} <br/>
                          <Button colorScheme="blue" variant="link"
                            onClick={() => selectViewStocks(product.id)}>
                            view stocks
                          </Button>
                        </Td>
                        <Td  p={2}>

                          <Flex flexDirection="row">

                            {authUser.auth.role != 'auditor'
                            ?
                            <Button p="0px" bg="transparent" onClick={() => selectEditItem(product.id)}>
                              <Flex color={textColor} cursor="pointer" align="center" p="12px">
                                <Icon as={FaPencilAlt} me="4px" />
                                <Text fontSize="xs" fontWeight="semibold">
                                  EDIT
                                </Text>
                              </Flex>
                            </Button>
                            : null
                            }

                            {authUser.auth.role != 'auditor'
                            ?
                            <Button p="0px" bg="transparent" onClick={() => {
                                setToAddStocks(product);
                                // setToViewStocks(product.id);
                              }}>
                              <Flex color={textColor} cursor="pointer" align="center" p="12px">
                                <Icon as={FaPlus} me="4px" />
                                <Text fontSize="xs" fontWeight="semibold">
                                  ADD STOCK
                                </Text>
                              </Flex>
                            </Button>
                            : null
                            }


                            {authUser.auth.role != 'auditor'
                            ?
                            <Button p="0px" 
                              bg="transparent" 
                              onClick={() => {
                                setToArchive(product);
                                onOpenArchive(true);
                              }}>
                              <Flex color={textColor} cursor="pointer" align="center" p="12px">
                                <Icon as={FaArchive} me="4px" />
                                <Text fontSize="xs" fontWeight="semibold">
                                  ARCHIVE
                                </Text>
                              </Flex>
                            </Button>
                            : null
                            }

                          </Flex>
                        </Td>
                      </Tr>
                    );
                  })
                }
              </Tbody>
            </Table>
            {gettingProducts
              ? null
              : <Pagination 
              totalItems={totalProducts}
              pageRows={pageLimit}
              currentPage={page}
              onPageChanged={setPage}
            />
            }
            
          </Flex>
        </CardBody>
      </Card>

    </Flex>
    
    <CreateProduct 
      isOpen={isOpenCreate}
      onClose={onCloseCreate}
      successCallback={reloadPage}
    />
           
    <EditProduct 
      isOpen={isOpenEdit}
      onClose={() => {
        setToEditProduct(null);
        onCloseEdit();
      }}
      successCallback={reloadPage}
      productData={toEditProduct}
    />


    <CreateStock 
      isOpen={isOpenCreateStock}
      onClose={() => {
        setToAddStocks(null);
        onCloseCreateStock();
      }}
      productData={toAddStocks}
      successCallback={() => {
        // setToViewStocks(toAddStocks);
        // setGettingStocks(true);
        setToAddStocks(null);
        reloadPage();
      }} 
    />


    <StockHistory 
      isOpen={isOpenViewStocks}
      onClose={() => {
        setToViewStocks(null);
        onCloseViewStocks();
      }}
      productData={toViewStocks}
      successCallback={() => {
        // setToViewStocks(toAddStocks);
        // setGettingStocks(true);
        setToViewStocks(null);
        reloadPage();
      }} 
    />



    <CreateProductArchive 
      isOpen={isOpenArchive}
      onClose={() => {
        setToArchive(null);
        onCloseArchive();
      }}
      productData={toArchive}
      successCallback={() => {
        setToArchive(null);
        reloadPage();
      }} 
    />
           
    {/* <EditStock
      isOpen={isOpenEditStock}
      onClose={() => {
        setToEditStock(null);
        onCloseEditStock();
      }}
      successCallback={() => {
        setGettingStocks(true);
      }}
      stockData={toEditStock}
    /> */}

    </>
  );
}

export default Inventory;
